import produce from "immer";
import { service } from '../config';
import { buttonDefault, imageDefault, textDefault } from '../config/components';
import { Container } from "../modules/editor";
import { isString } from '../util/validator';
import { cleanUpHtml, removeEventHandlers } from "./html";
import { copyObject } from "./object";
import { valueToNumber, valueToString } from "./string";

const { resource } = service;
const dummyImagePath = `${resource}/editor/dummy/dummy_image.png`;
const dummyMapPath = `${resource}/editor/dummy/dummy_map.png`;
const dummyVideoPath = `${resource}/editor/dummy/dummy_video.png`;
const dummyHeaderPath = `${resource}/editor/dummy/dummy_header.png`;

const BASIC_LINE_HEIGHT = '1.7';
const TEXT_TEMPLATE_LINE_HEIGHT = '1.5';

const ctaPaddingBySize = {
	// '12px': '12px 18px 10px',
	// '14px': '12px 20px 10px',
	// '16px': '14px 24px 11px',
	// '18px': '15px 26px 12px',
	// '20px': '15px 28px 12px',
	// '26px': '15px 32px 12px',
	// '32px': '18px 30px 14px',
	// '40px': '18px 30px 14px',
	// '48px': '18px 30px 14px',
	// '60px': '18px 30px 14px',
	'12px': '17px 18px',
	'14px': '17px 20px',
	'16px': '19px 20px',
	'18px': '20px 26px',
	'20px': '20px 28px',
	'26px': '20px 32px',
	'32px': '23px 30px',
	'40px': '23px 30px',
	'48px': '23px 30px',
	'60px': '23px 30px',
}

export function legacyContentControl(input:any, isOld?:boolean, templateId?: number) {	
		
	if (input.length === 0) {
		return null;
	}
	
	if (isString(input)) {
		input = JSON.parse(input);
	}		

	if (input.content[0].hasOwnProperty('text')) {
		input.content[0]['text'] = removeEventHandlers(cleanUpHtml(input.content[0].text, input.type));
	}
	if (input.content[1] && input.content[1].hasOwnProperty('text')) {
		input.content[1]['text'] = removeEventHandlers(cleanUpHtml(input.content[1].text, input.type));
	}	
	
	// 에디팅 초기화 
	input.editing = false;

	// 컬럼 정보(순서 등) 추가
	if (input.content.length === 1) {
		input.column = input.column || [[]]
	} else if (input.content.length === 2) {
		input.column = input.column || [[],[]]
	}	else {
		input.column = input.column || [[]];
	}
	
	// 컬럼 값 추가
	if (input.column[0].length === 0) {
		switch (input.type) {
			case 'textOnly':
				input.column[0] = ['text'];
				break;
			case 'imageOnly':
				input.column[0] = ['image'];
				break;
		case 'CTAOnly':
			input.column[0] = ['cta'];
			break;
		case 'naver-ad':
			input.column[0] = ['ad'];
			break;
		case 'footer':
			input.column[0] = ['text'];
			break;
		case 'header':
			input.column[0] = ['image'];
			break;
			case 'cntB':
				input.column[0] = ['image'];
				input.column[1] = ['text', 'cta'];
				break;
			case 'cntD':
				input.column[0] = ['image'];
				input.column[1] = ['text'];
				break;
				
			case 'multiA':
				input.column[0] = ['image','text','cta'];
				input.column[1] = ['image','text','cta'];
				break;
			case 'multiB':
				input.column[0] = ['image','text'];
				input.column[1] = ['image','text'];
				break;
			case 'multiC':
				input.column[0] = ['image'];
				input.column[1] = ['image'];
				break;
			case 'multiD':
				input.column[0] = ['text'];
				input.column[1] = ['text'];
				break;
			case 'multiE':
				input.column[0] = ['cta'];
				input.column[1] = ['cta'];
				break;
			case 'textButton':
				input.column[0] = ['text', 'cta'];
				break;
			case 'shopA':
				input.column = [['image', 'text', 'text', 'text', 'text', 'cta']];
				break;
			case 'shopB':
				input.column[0] = ['image'];
				input.column[1] = ['text', 'text', 'text', 'text', 'cta'];
				break;
			case 'shopC':
				input.column[0] = ['image', 'text', 'text', 'text', 'text', 'cta'];
				input.column[1] = ['image', 'text', 'text', 'text', 'text', 'cta'];
				break;
			case 'donationA':
				input.column = [['cta']];
				break;
		
			default:
				break;
		}
	}	
	
	// 타입 변환
	const convertBase = ['textOnly', 'imageOnly', 'CTAOnly', 'cntB', 'cntD', 'multiA', 'multiB', 'multiC', 'multiD', 'multiE', 'textButton', 'header'];

	const convertShop = ['shopA', 'shopB', 'shopC'];
	const convertDonation = ['donationA', 'donationB'];
		
	input['category'] = input['category'] || '';

	if (convertBase.includes(input.type)) {
		input['category'] = 'base';
	} else if (convertShop.includes(input.type)) {
		input['category'] = 'shop';
	} else if (convertDonation.includes(input.type)) {
		input['category'] = 'donation';
	} else {
		input['category'] = input['type'];
	}

	if (Array.isArray(input.content[0])) {
		input.content.map((item: any) => {		
			item.map((subItem:any) => {
				if (subItem.imagePath && subItem.imagePath.includes('dummy')) {
					subItem.imagePath = dummyImagePath;
				}
			});
		});
		return input; // 상품 상자일 때
	}

	// 컨텐츠 정리 
	switch (input.type) {
		case 'cntB':
			input.content[1] = input.content[1] || [];
			if (input.content[1].length === 0) {
				input.content[1] = input.content[0];
			}
			break;
		case 'cntD':
			input.content[1] = input.content[1] || [];
			if (input.content[1].length === 0) {
				input.content[1] = input.content[0];
			}
			break;

		case 'multiB':	
			
			break;

		default:
			break;
	}	
	
	// 이, 텍, 버 기본값 없는 경우 

	input.content[1] = input.content[1] || {}
	input.style[1] = input.style[1] || {}

	input.style[0].text = input.style[0].text || {}
	input.style[0].image = input.style[0].image || {}
	input.style[0].button = input.style[0].button || {}
	input.style[1].text = input.style[1].text || {}
	input.style[1].image = input.style[1].image || {}
	input.style[1].button = input.style[1].button || {}

	if (input.style[0].button.fontSize === undefined) {
		input.style[0].button = buttonDefault;
		input.style[1].button = produce(input.style[0].button, (draft: any) => { })
	}
	if (input.style[0].image.width === undefined) {
		input.style[0].image = imageDefault;
		input.style[1].image = produce(input.style[0].image, (draft: any) => { })
	}
	if (input.style[0].text.fontSize === undefined) {
		input.style[0].text = textDefault;
		input.style[1].text = produce(input.style[0].text, (draft: any) => { })
	}

	try {
		input.style[0].button['buttonType'] = input.style[0].button.borderRadius === '500px' ? 'round-full' : 'square-full';
		input.style[1].button['buttonType'] = input.style[1].button.borderRadius === '500px' ? 'round-full' : 'square-full';
	} catch(error) {
		console.error(error);
	}

	// line-height 보정 
	//구버전 에디터 전환시 line height를 조작하는 부분이었음. 
	//전환한지 오래되어 제거하도 상관없음. 
	// 추후 버전 업데이트 시 참고 필요 시 주석 해제 필요. 
	try {
		// templateId가 30이면 lineHeight를 1.5로, fontSize를 12px로 보정
		if (templateId === 30) {
			if (input.style[0].text) {
				input.style[0].text.lineHeight = TEXT_TEMPLATE_LINE_HEIGHT;
				input.style[0].text.fontSize = '12px';
			}
			if (input.style[1].text) {
				input.style[1].text.lineHeight = TEXT_TEMPLATE_LINE_HEIGHT;
				input.style[1].text.fontSize = '12px';
			}
		}

		// if (input.style[0].text?.lineHeight !== undefined) {
		// 	input.style[0].text.lineHeight = BASIC_LINE_HEIGHT;
		// }
	
		// if (input.style[1].text?.lineHeight !== undefined) {
		// 	input.style[1].text.lineHeight = BASIC_LINE_HEIGHT;
		// }
	
		// if (input.style[0].box.lineHeight !== undefined) {
		// 	input.style[0].box.lineHeight = BASIC_LINE_HEIGHT;
		// }
	
		// if (input.style[1].box?.lineHeight !== undefined) {
		// 	input.style[1].box.lineHeight = BASIC_LINE_HEIGHT;
		// }

	} catch (error) {
		console.error(error);
	}		

	// isOld 박스 스타일
	if (isOld) {	
		try {	
			if (input.column.length === 1 && (input.style[0]['box']['paddingLeft'] === '0'|| input.style[0]['box']['paddingLeft'] === '0px'|| input.style[0]['box']['paddingLeft'] === 0) || input.style[0]['box']['paddingLeft'] === undefined || input.style[0]['box']['paddingLeft'] === null) {
				input.style[0]['box']['paddingLeft'] = '15px';
				input.style[0]['box']['paddingRight'] = '15px';
			}
		} catch (error) {
			console.error(error);
		}

		if (input.style[0].box) {
			input.style[0].box.paddingLeft = valueToString(input.style[0].box.paddingLeft);
		}
		
		if (input.style[1].box) {
			input.style[1].box.paddingLeft = valueToString(input.style[1].box.paddingLeft)
		}
		
		if (input.style[0].box.paddingLeft === undefined) {
			input.style[0].box.paddingLeft = '15px';
		}
		if (input.style[1].box && input.style[1].box.paddingRight === undefined) {
			input.style[1].box.paddingRight = '15px';
		}

		try {
			input.style[0]['text']['margin'] = '0'; 
			input.style[1]['text']['margin'] = '0'; 
	
		} catch (error) {
			console.error(error);
		}

		try {
			if ((input.type.includes('cnt') || input.type.includes('multi')) && valueToNumber(input.style[0].box?.paddingLeft) === 0) {
				input.style[0]['box']['paddingLeft'] = '15px';
				input.style[0]['box']['paddingRight'] = '15px';
				input.style[1]['box']['paddingLeft'] = '15px';
				input.style[2]['box']['paddingRight'] = '15px';
			}
			
		} catch (error) {
			console.error(error);
		}
	
	}

	// 버튼 display, 패딩 보정 
	try {
		input.style[0].button.padding = ctaPaddingBySize[input.style[0].button['fontSize']];
		input.style[1].button.padding = ctaPaddingBySize[input.style[1].button['fontSize']];
		input.style[0].button.display = 'inline-block';
		input.style[1].button.display = 'inline-block';
	} catch (error) {
		console.error(error);
	}

	// 버튼 fullWidth  보정
	try {
		if (input.style[0].button.width == '100%') {
			input.style[0].button['fullWidth'] = 'wide';
		}
		if (input.style[1].button.width == '100%') {
			input.style[1].button['fullWidth'] = 'wide';
		}
	} catch (error) {
		console.error(error);
	}

	// cnt 타입 버튼 스타일 보정
	if (input.style[1].button.background === undefined) { 
		if (input.style[0].button.background === undefined) {
			input.style[1].button = buttonDefault;
		} else {
			input.style[1].button = copyObject(input.style[0].button);
		}
	}
	
	// 20px(구, 넓게) 보정
	input.style[0].box.paddingTop = input.style[0].box.paddingTop === '20px' ? '25px' : input.style[0].box.paddingTop;
	input.style[0].box.paddingBottom = input.style[0].box.paddingBottom === '20px' ? '25px' : input.style[0].box.paddingBottom;
	input.style[0].box.paddingLeft = input.style[0].box.paddingLeft === '20px' ? '25px' : input.style[0].box.paddingLeft;
	input.style[0].box.paddingRight = input.style[0].box.paddingRight === '20px' ? '25px' : input.style[0].box.paddingRight;

	if (input.column.length === 2 && !Array.isArray(input.style[0])) {
		// 컬럼 스타일 추가
		input.style[0].column = input.style[0].column || {
			// paddingLeft: '15px',
			// paddingRight: '15px'
		}
	} else {
		input.style[0].column = input.style[0].column || {}
	}
	
	// 아우터 (마진) 스타일 추가
	input.style[0].outer = input.style[0].outer || {}
	
	input.content.map((item: any) => {
		//s3 이미지 url 보정
		if (item.imagePath && item.imagePath.includes('s3.ap-northeast-2.amazonaws.com/')) {
			item.imagePath = item.imagePath.replace('s3.ap-northeast-2.amazonaws.com/','');
		}
		if (item.imagePath && item.imagePath.includes('dummy_map')) {
			item.imagePath = dummyMapPath;
		} else if (item.imagePath && item.imagePath.includes('dummy')) {
			item.imagePath = dummyImagePath;
		}

		if ((item.imagePath && item.imagePath.includes('dummy') && input.category === 'video')) {
			item.imagePath = dummyVideoPath;
		}	
		if ((item.imagePath && item.imagePath.includes('dummy') && input.category === 'header')) {
			item.imagePath = dummyHeaderPath;
		}
	});

	if (input.category === 'partition') {
		input.style[0].partition['margin'] = '0 0';
	}

	// snsStyle - 공유 변환
	if (input.category === 'share') {
		input.content[0].share = produce(input.content[0].share, (draft:any) => {
			draft.map((item: any, index: number) => {
				item['id'] = item['id'] || index;
				item['value'] = item['value'] || item['name'];
				item['label'] = item['label'] || item['text'];
				switch(item['label']) {
					case '페이스북에 공유하기':
						item['label'] = '공유하기';
						break;
					case 'X에 공유하기':
						item['label'] = '게시하기';
						break;
				}
				item['active'] = item['active'] ? item['active'] : item['show'] === 'show' ? true : false;
				delete item['$$hashKey'];
				delete item['name'];
				delete item['text'];
				delete item['show'];
				return item;
			})
		})
	}

	// snsStyle - SNS 변환
	if (input.category === 'sns') {		
		input.content[0].sns = produce(input.content[0].sns, (draft: any) => {
			draft.map((item: any, index: number) => {
				item['id'] = item['id'] || index;
				item['value'] = item['value'] || item['name'];
				item['label'] = item['label'] || item['text'];
				item['active'] = item['active'] ? item['active'] : item['show'] === 'show' ? true : false;
				delete item['$$hashKey'];
				delete item['name'];
				delete item['text'];
				delete item['show'];
				delete item['icon'];
				delete item['icon_g'];
				delete item['background'];
				return item;
			});			
		});

		input.content[0].sns = input.content[0].sns.filter((item:any) => {return item.active});
	}
	
	return input;	
}

export function legacyContainerControl(input: Container, templateId?: number) {
	return produce(input, (draft: any) => {
		draft.commonStyle['outer'] = draft?.commonStyle?.outer || {};
		draft.commonStyle['column'] = draft?.commonStyle?.column || {};
		
		// 기본 버튼 패딩 변경
		draft.commonStyle = draft?.commonStyle || {};		
		if (draft.commonStyle.button.padding === '14px 20px 11px') {
			draft.commonStyle.button.padding = '19px 20px';
		}

		draft.commonStyle.box.paddingTop = draft.commonStyle.box.paddingTop === '20px' ? '25px' : draft.commonStyle.box.paddingTop;
		draft.commonStyle.box.paddingBottom = draft.commonStyle.box.paddingBottom === '20px' ? '25px' : draft.commonStyle.box.paddingBottom;

		// templateId가 30이면 lineHeight를 1.5로, fontSize를 12px로 보정
		if (templateId === 30) {
			draft.commonStyle.text['lineHeight'] = '1.5';
			draft.commonStyle.text['fontSize'] = '12px';
		}

		draft.commonStyle.button['lineHeight'] = 1;

		draft.commonStyle.partition['margin'] = '0 0';
	});
} 
